module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_square_red.dc8edc06.png";